module.exports = __webpack_public_path__ + "static/media/WhatsAppIconWhite.9e4f505b.svg";